export default {
  name: "RedirectModal",
  props: ["close"],
  data() {
    return {};
  },
  methods: {
    closeModal() {
      this.$store.dispatch("closeRedirectModal");
    },
  },

  mounted() {},
};
